namespace gotoAndPlay {
    $(document).on('click', '.js-hero-down', Helpers.scrollTo);
}
